export default "__VITE_ASSET__CWQipgOJ__"